import { useEffect, useState } from "react";
import {
  IDenunciaForm,
  ITestemunhaForm,
  ITestemunhaFormCreate,
} from "../../../../types/denuncia";
import { v4 } from "uuid";
import { toast } from "react-toastify";
import { TIPOS_DE_ASSEDIOS } from "../../../../constants/tipos_de_assedios";
import { MEDIDAS_PREVENTIVAS } from "../../../../constants/medidas_preventivas";

type SubmitFormProps = {
  hanldleSubmit: (data: IDenunciaForm) => void;
  e: React.FormEvent<HTMLFormElement>;
};

const ASSEDIOS_OPTIONS = Object.entries(TIPOS_DE_ASSEDIOS).map(
  ([key, value]) => ({
    value: key,
    label: value,
  })
);

const DEMANDAS_OPTIONS = Object.entries(MEDIDAS_PREVENTIVAS).map(
  ([key, value]) => ({
    value: key,
    label: value,
  })
);

export const useFormComplaint = () => {
  const [isAnonymous, setAnonymous] = useState(false);
  const [form, setForm] = useState<IDenunciaForm>({} as IDenunciaForm);
  const [testemunha, setTestemunha] = useState<ITestemunhaFormCreate>(
    {} as ITestemunhaFormCreate
  );
  const [testemunhas, setTestemunhas] = useState<ITestemunhaFormCreate[]>(
    [] as ITestemunhaFormCreate[]
  );

  function handleAddTestemunha() {
    if (testemunha.nome && testemunha.cargo) {
      setTestemunhas((prev) => [...prev, { ...testemunha, uuid: v4() }]);
      setTestemunha({ cargo: "", nome: "", uuid: "" });
      return;
    }

    toast.error("Você precisa preencher os campos Nome e Cargo.");
  }

  function handleDeleteTestemunha(id: string) {
    setTestemunhas((prev) => prev.filter((i) => i.uuid !== id));
  }

  function submitForm({ e, hanldleSubmit }: SubmitFormProps) {
    e.preventDefault();

    const Data_testemunhas: ITestemunhaForm[] = testemunhas.map((t) => ({
      nome: t.nome,
      cargo: t.cargo,
    }));

    const data: IDenunciaForm = { ...form, testemunhas: Data_testemunhas };
    hanldleSubmit(data);
  }

  function updateForm(data: Partial<IDenunciaForm>) {
    setForm((prev) => ({ ...prev, ...data }));
  }

  useEffect(() => {
    if (isAnonymous) {
      updateForm({
        nomeColaborador: "",
        dataAdmissao: "",
        cargoColaborador: "",
        setorColaborador: "",
      });
    }
  }, [isAnonymous]);

  useEffect(() => {
    if (!form.procurouSuperior) {
      updateForm({
        nomeSuperior: "",
      });
    }
  }, [form.procurouSuperior]);

  return {
    form,
    updateForm,
    submitForm,
    isAnonymous,
    setAnonymous,
    testemunha,
    setTestemunha,
    testemunhas,
    handleDeleteTestemunha,
    handleAddTestemunha,
    ASSEDIOS_OPTIONS,
    DEMANDAS_OPTIONS,
  };
};
